frappe.ui.form.ControlInt = frappe.ui.form.ControlInt.extend({
	eval_expression: function (value) {
		//console.log(value);
		if (typeof value === 'string') {
			if (value.match(/^[0-9+\-/*. ]+$/)) {
				// If it is a string containing operators
				try {
					return eval(value);
				} catch (e) {
					// bad expression
					return value;
				}
			}
		}
		return value;
	}
});

frappe.ui.form.ControlLongInt = frappe.ui.form.ControlInt;
